import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import Switch from 'react-switch';

export default class CalculatorInputToggle extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            value: props.defaultValue
        };

        this.handleToggleChange = this.handleToggleChange.bind(this);
    }

    handleToggleChange(checked) {
        const { onValue, offValue } = this.props;
        const value = checked ? onValue : offValue;
        this.props.processInput(this.props.id, value);
        this.setState({
            value
        });
    }

    render() {
        const { id, label, onLabel, onValue, offLabel } = this.props;
        const { value } = this.state;

        return (
            <FormGroup controlId={id}>
                <ControlLabel>{label}</ControlLabel><br />
                <div
                    css={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <span css={{ marginRight: 24 }}>{offLabel}</span>
                    <Switch
                        id={id}
                        checked={value === onValue}
                        onChange={this.handleToggleChange}
                        onColor="#86d3ff"
                        onHandleColor="#2693e6"
                        offColor="#86d3ff"
                        offHandleColor="#2693e6"
                        handleDiameter={30}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.5)"
                        height={18}
                        width={48}
                    />
                    <span css={{ marginLeft: 24 }}>{onLabel}</span>
                </div>
            </FormGroup>
        );
    }
}

CalculatorInputToggle.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    defaultValue: PropTypes.string.isRequired,
    processInput: PropTypes.func.isRequired,
    onLabel: PropTypes.string.isRequired,
    onValue: PropTypes.string.isRequired,
    offLabel: PropTypes.string.isRequired,
    offValue: PropTypes.string.isRequired,
};
